import {
  Box,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import { OrderItemModel } from '../../../config/types/models/OrderItemModel';
import { useBackendTranslate } from '../../../hooks/settings/useBackendTranslation';
import { useSettings } from '../../../hooks/settings/useSettings';

type IProps = {
  orderItems: OrderItemModel[];
  totalProductPrice: number;
  shippingPrice: number | null;
  discount: number | null;
  membershipDiscount: number | null;
  total: number;
};

function OrderItem({ orderItem }: { orderItem: OrderItemModel }) {
  const getTranslation = useBackendTranslate();
  return (
    <TableRow>
      <TableCell>{orderItem.product.reference}</TableCell>
      <TableCell>
        <img src={orderItem.product.image} style={{ width: 100 }} />
      </TableCell>
      <TableCell>{getTranslation(orderItem.product, 'name')}</TableCell>
      <TableCell>{orderItem.quantity}</TableCell>
      <TableCell>{orderItem.product.unit}</TableCell>
      <TableCell>{orderItem.product.price}</TableCell>
      <TableCell>{orderItem.price}</TableCell>
    </TableRow>
  );
}
function OrderItems({
  orderItems,
  totalProductPrice,
  shippingPrice,
  discount,
  membershipDiscount,
  total,
}: IProps) {
  const t = useTranslate();
  const { data: settings } = useSettings();
  return (
    <Paper sx={{ width: '100%' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('ref')}</TableCell>
            <TableCell>{t('image')}</TableCell>
            <TableCell>{t('name')}</TableCell>
            <TableCell>{t('quanitity')}</TableCell>
            <TableCell>{t('unit')}</TableCell>
            <TableCell>{t('price')}</TableCell>
            <TableCell>{t('totalPrice')}</TableCell>
          </TableRow>

          {orderItems?.map((orderItem) => (
            <OrderItem key={orderItem.id} orderItem={orderItem} />
          ))}
        </TableHead>
      </Table>
      <Box sx={{ padding: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>{t('totalProductPrice')}</Typography>
          <Typography>
            {totalProductPrice}
            <span>{settings.currency}</span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>{t('shippingPrice')}</Typography>
          <Typography>
            {`${shippingPrice}`}
            <span>{settings.currency}</span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>{t('discount')}</Typography>
          <Typography>
            - {`${discount}`} <span>{settings.currency}</span>{' '}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>{t('membershipDiscount')}</Typography>
          <Typography>
            - {` ${membershipDiscount} `} <span>{settings.currency}</span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>{t('total')}</Typography>
          <Typography>
            {` ${total}`} <span>{settings.currency}</span>
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

export default OrderItems;
